import { Component, Input, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';
import { RpaConnectorDetail } from 'app/rpa-bots/core/rpa-details-details.types';
import { NgForm } from '@angular/forms';
import { AuthType, ConstAuthClientCredentials, UipathConnectionType } from '../common/models/enums';
import { BzgRadioChange } from 'bz-genome-angular/radio/radio-button/radio-button.component';
import { BzgModalService } from 'bz-genome-angular';
import { ConfirmModalComponent } from '../common-components/confirm-modal/confirm-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';

@Component({
    selector: 'uipath-configuration',
    templateUrl: 'uipath-configuration.component.html',
    styleUrls: ['uipath-configuration.component.scss']
})
export class UipathConfigurationComponent implements OnInit {
    private _botDetailData: RpaConnectorDetail;
    private _originalConnection: RpaConnectorDetail;
    public chartsVisible: boolean;
    public retriesVisible: boolean;
    public URL_REGEXP = /^((((https?|ftps?):\/\/))(%[0-9A-Fa-f]{2}|[-()_.!~*';\/?:@&=+$,A-Za-z0-9])+)([).!';\/?:,][[:blank:]])?$/;
    public uipathConnectionType = UipathConnectionType;
    public authType = AuthType;
    public constAuthClientCredentials = ConstAuthClientCredentials;
    change_onPremisoToCloudTitle: string;
    change_onPremisoToCloudMessage: string;

    @Output() save = new EventEmitter<any>();
    @Output() testConnection = new EventEmitter<any>();
    @Input()
    public get botDetail(): RpaConnectorDetail {
        return (this._botDetailData as IRpaConnectionUiPath);
    }
    @Input() public uiPathOriginalConnection: IRpaConnectionUiPath;
    @ViewChild('botConfigForm', { static: false}) botConfigForm: NgForm;

    constructor(private _modalService: BzgModalService, private translate: TranslateService,) {
    }
    ngOnInit(): void {
        this.translate.get('RPA_BOTS.CONFIRMATION').subscribe(translation => {
            this.change_onPremisoToCloudTitle = translation;
        });
        this.translate.get('RPA_BOTS.CHANGE_DATA_CONFIGURACION').subscribe(translation => {
            this.change_onPremisoToCloudMessage = translation;
        });
    }

    public set botDetail(value: RpaConnectorDetail) {
        this._botDetailData = value;
        this._originalConnection = _.cloneDeep(this._botDetailData);
    }

    public botDetailData: IRpaConnectionUiPath;

    onClearAll() {
        this._botDetailData.server = '';
        this._botDetailData.password = '';
        if ((this._botDetailData as IRpaConnectionUiPath)) {
            (this._botDetailData as IRpaConnectionUiPath).tenancyName = '';
            (this._botDetailData as IRpaConnectionUiPath).userNameOrEmailAddress = '';
        }
        this.botConfigForm.reset();
        (this.botDetail as IRpaConnectionUiPath).authType = AuthType.apiAccess;
        (this.botDetail as IRpaConnectionUiPath).grantType = ConstAuthClientCredentials.grantType;
        (this.botDetail as IRpaConnectionUiPath).authUrl = ConstAuthClientCredentials.authUrl;
    }

    isValid(): boolean {
        return !this.botConfigForm || this.botConfigForm.valid;
    }

    onTestConnection() {
        this.testConnection.emit();
    }

    onSave() {
        this.showConfirmDialog(() => { this.save.emit(this._botDetailData); })
    }

    get hasChanges(): boolean {
        return !_.isEqual(this._originalConnection, this._botDetailData);
    }

    showCharts() {
        this.chartsVisible = true;
        this.retriesVisible = false;
    }

    showRetries() {
        this.retriesVisible = true;
        this.chartsVisible = false;
    }

    closeCharts() {
        this.chartsVisible = false;
    }

    closeRetries() {
        this.retriesVisible = false;
    }

    selectConnectionType(connectionType: string) {
        (this.botDetail as IRpaConnectionUiPath).connectionType = connectionType;
    }

    changeConnectionTypeDev(type: UipathConnectionType) {
        this.botDetail.connectionType = type;
        if (this.botDetail && !(this.botDetail as IRpaConnectionUiPath).authType) {
            (this.botDetail as IRpaConnectionUiPath).authType = type;
        }
    }

    public showConfirmDialog(callback) {
        const deleteModal = this._modalService.open(ConfirmModalComponent, {
            closeOnBackdropClick: false,
            closeOnRouterNavigation: true,
            data: {
                title: this.change_onPremisoToCloudTitle,
                message: this.change_onPremisoToCloudMessage,
                button: "OK"
            }
        });
        deleteModal.afterClosed().subscribe((result: string) => {
            if (result === 'ok') {
                callback();
            }
        })
    }
}
